(function () {
	const header = () => {
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);

	};

	document.addEventListener("shopify:section:load", header);
	header();
})();


window.onload = function () {
	const header = document.querySelector("nav.header__nav");

	const custom_menu = header.querySelectorAll("[js-custom-menu]");
	custom_menu.forEach((item) => {
		item.addEventListener("mouseover", (event) => {
			const nestedItem = event.target.closest("[data-item]");
			if (nestedItem) {
				const dataItemValue = nestedItem.getAttribute("data-item");
				const elements = document.querySelectorAll("[data-item-menu]");
	
				elements.forEach((element) => {
					if (element.getAttribute("data-item-menu") === dataItemValue) {
						element.style.display = "flex";
					} else {
						element.style.display = "none";
					}
				});
			}
		});
	});

	document.querySelectorAll('[data-menu-item]').forEach(item => {
		item.addEventListener('mouseenter', () => {
				const value = item.getAttribute('data-menu-item');
				document.querySelectorAll('.custom-menu_image_item').forEach(imageItem => {
						imageItem.style.display = 'none';
				});
				const imageToShow = document.querySelector(`.custom-menu_image_item[data-menu-item="${value}"]`);
				if (imageToShow) {
						imageToShow.style.display = 'block';
				}
		});
	});
};